import React, {Component, Fragment} from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {LOGO} from './utilities';


const PSCS = [
  {code: "PSC229", address: "229 49th Street, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC833", address: "833 58th Street, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC763", address: "763 56th Street, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC55", address: "818 55TH Street, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},  
  {code: "PSC395", address: "395 Pearl Street STE 202, Brooklyn, NY 11202", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC629", address: "629 West 185th Street, New York, NY 10033", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: 'PSC19', address: '19 Hamilton Place, New York, NY 10031', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC217", address: "217 Grand Street STE 403, New York, NY 10013", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC136", address: "136-21 Franklin Ave 3C-2, Flushing, NY 11355", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC4626", address: "4626 White Plains Rd STE 100, Bronx, NY 10470", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC1108", address: "1108 Brooke Ave, Bronx, NY 10456", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: "PSC90", address: "90 New Main Street, Haverstraw, NY 10927", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},  
  {code: 'PSC550', address: '550 West Merrick Rd, STE 3, Valley Stream, NY 11580', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: 'PSC9171', address: '91-71 111 Street Richmond Hill, NY, 11418', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: 'PSC9229', address: '92-29 Queens Blvd STE 2D, Rego Park, NY, 11374', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: 'PSC203', address: '203 Old Town Road, Staten Island 10305', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: 'PSC5458', address: '5458 Town Center Road STE 4, Boca Raton FL 33486', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
  {code: 'PSC2180', address: '2180 SW 71st Terrace, Davie FL 33317', off :['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00'},
]

const states = [ { "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, 
{ "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, 
{ "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, 
{ "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, 
{ "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, 
{ "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, 
{ "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, 
{ "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, 
{ "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, 
{ "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, 
{ "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, 
{ "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, 
{ "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" } ]

const dateMask = (value) => {
  var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
  return value = !x[2] ? x[1] : x[1]+ '/' + x[2] + (x[3] ? '/' + x[3] : '')
}

class Kameo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lastName: "",
      isValidLastName: "",
      firstName: "",
      isValidFirstName: "",
      dob: "",
      isValidDOB: "",
      gender: "",
      isValidGender: "",
      email: "",
      isValidEmail: "",
      phone: "",
      isValidPhone: "",
      address: "",
      isValidAddress: "",
      city: "",
      isValidCity: "",
      state: "",
      isValidState: "",
      zip: "",
      isValidZip: "",
      isInsured: "No",
      isValidInsured: "",
      insuranceName: "",
      isValidInsurance: "",
      policy: "",
      isValidPolicy: "",
      relation: "",
      isValidRelation: "",
      holderName: "",
      isValidHolder: "",
      race: "",
      isValidRace: "",
      ethnicity: "",
      isValidEthnicity: "",
      symptoms: {
        severe: 0,
        mild: 0,
        no: 0
      },
      isValidSymptoms: "",
      exposure: {
        no: 0,
        suspect: 0,
        yes: 0,
      },
      isValidExposure: "",
      category: {
        high: 0,
        low: 0,
      },
      isValidCategory: "",
      isHigh: false,
      isLow: false,
      psc: window.location.href.split('?')[1] ? "PSC2180" : '',
      isValidPSC: "",
      date: "",
      isValidDate: "",
      errors: [],
      busySlots: [],
      submitted: false,
      modal: false,
      loading: false,
      consent: false,
      pcr: true,
      nab: false,
      panel: false,
    }
  }

  onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if(name === "dob"){
      this.setState({
        [name]:dateMask(value)
      })
    } else if (name === 'relation' && value === 'Self'){
      this.setState({
        [name]:value,
        holderName: `${this.state.firstName} ${this.state.lastName}`
      })
    } else {
      this.setState({
        [name]:value
      })
    }
    
  }

  onChangeSymptoms = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.symptoms};
    newSym[key] = value
    this.setState({
      symptoms: newSym
    })
  }

  onChangeExposure = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.exposure};
    newSym[key] = value
    this.setState({
      exposure: newSym
    })
  }

  onChangeTest = (e) => {
    this.setState({
      [e.target.name]: !this.state[e.target.name]
    })
  }

  onChangeRisk = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.category};
    newSym[key] = value
    this.setState({
      category: newSym
    })
  }

  clickHigh = () => {
    this.setState({
      isHigh: !this.state.isHigh
    })
  }

  clickLow = () => {
    this.setState({
      isLow: !this.state.isLow
    })
  }

  submit = () => {
    this.setState({
      loading: true
    })
    let errors = [];
    let isValid = true;
    let newState = {...this.state}
    if (!this.state.firstName){
      isValid = false;
      newState.isValidFirstName = "input-error";
      errors.push('First Name is Required');
    }
    if (!this.state.lastName){
      isValid = false;
      newState.isValidLastName = "input-error";
      errors.push('Last Name is Required')
    }
    if (!this.state.dob){
      isValid = false;
      newState.isValidDOB = "input-error";
      errors.push('Date of Birth is Required')
    }
    if (!this.state.gender){
      isValid = false;
      newState.isValidGender = "input-error";
      errors.push('Gender is Required')
    }
    if (!this.state.email){
      isValid = false;
      newState.isValidEmail = "input-error";
      errors.push('Email is Required')
    }
    if (!this.state.phone){
      isValid = false;
      newState.isValidPhone = "input-error";
      errors.push('Phone is Required')
    }
    if (!this.state.address){
      isValid = false;
      newState.isValidAddress = "input-error";
      errors.push('Address is Required')
    }
    if (!this.state.city){
      isValid = false;
      newState.isValidCity = "input-error";
      errors.push('City is Required')
    }
    if (!this.state.state){
      isValid = false;
      newState.isValidState = "input-error";
      errors.push('State is Required')
    }
    if (!this.state.zip){
      isValid = false;
      newState.isValidZip = "input-error";
      errors.push('Zip Code is Required')
    }
    if (!this.state.isInsured){
      isValid = false;
      newState.isValidInsured = "input-error";
      errors.push('Please indicate if you have an insurance')
    }
    if (this.state.isInsured === 'Yes'){
      if (!this.state.insuranceName){
        isValid = false;
        newState.isValidInsurance = "input-error";
        errors.push('Insurance Name is Required')
      }
      if (!this.state.policy){
        isValid = false;
        newState.isValidPolicy = "input-error";
        errors.push('Policy Number is Required')
      }
      if (!this.state.relation){
        isValid = false;
        newState.isValidRelation = "input-error";
        errors.push('Relation to Insured is Required')
      }
      if (!this.state.holderName){
        isValid = false;
        newState.isValidHolder = "input-error";
        errors.push('Policy Holder Name is Required')
      }
    }
    if (!this.state.race){
      isValid = false;
      newState.isValidRace = "input-error";
      errors.push('Race is Required')
    }
    if (!this.state.ethnicity){
      isValid = false;
      newState.isValidEthnicity = "input-error";
      errors.push('Ethnicity is Required')
    }
    if (!this.state.psc){
      isValid = false;
      newState.isValidPCS = "input-error";
      errors.push('Location is Required')
    }
    if (!this.state.date){
      isValid = false;
      newState.isValidDate = "input-error";
      errors.push('Date is Required')
    }
    if (!this.state.pcr && !this.state.nab && !this.state.panel){
      isValid = false;
      errors.push('Test is Required')
    }
    if (!this.state.symptoms.severe && !this.state.symptoms.mild && !this.state.symptoms.no){
      isValid = false;
      newState.isValidSymptoms = "input-error";
      errors.push('What are you symptoms?')
    }
    if (!this.state.exposure.no && !this.state.exposure.suspect && !this.state.exposure.yes){
      isValid = false;
      newState.isValidExposure = "input-error";
      errors.push('Have you been exposed?')
    }
    if (!this.state.category.high && !this.state.category.low){
      isValid = false;
      newState.isValidCategory = "input-error";
      errors.push('Are you a High or Low Risk?')
    }
    if (!this.state.consent){
      isValid = false;
      errors.push("Please acknowledge that you read Consent Form")
    }
    if (isValid) {
      let formData = {...this.state};
      formData.dob = moment(this.state.dob, "MM/DD/YYYY").format("YYYY-MM-DD");
      formData.location = PSCS.filter(item => item.code === this.state.psc)[0].address;
      if (window.location.href.split('?')[1]){
        formData.acula = 1;
      } else {
        formData.acula = 0;
      }
      if (this.state.panel){
        formData.test = 'panel'
        if (this.state.nab){
          formData.test = 'panelNab'
        }
      } else {
        if (this.state.pcr){
          formData.test = 'pcr'
          if (this.state.nab){
            formData.test = 'pcrNab'
          }
        } else {
          formData.test = 'nab'
        }
      }
      
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/appointment-kameo`,
        data: formData,
      }).then(res => {
        window.location.href = "https://www.empirecitylabs.com/thank-you-for-your-submission/";
      }).catch(err => {
        console.log(err)
      })
    } else {
      newState.errors = errors;
      this.setState(newState)
    }
  }

  back = () => {
    this.setState({
      lastName: "",
      isValidLastName: "",
      firstName: "",
      isValidFirstName: "",
      dob: null,
      isValidDOB: "",
      gender: "",
      isValidGender: "",
      email: "",
      isValidEmail: "",
      phone: "",
      isValidPhone: "",
      address: "",
      isValidAddress: "",
      city: "",
      isValidCity: "",
      state: "",
      isValidState: "",
      zip: "",
      isValidZip: "",
      isInsured: "",
      isValidInsured: "",
      insuranceName: "",
      isValidInsurance: "",
      policy: "",
      isValidPolicy: "",
      relation: "",
      isValidRelation: "",
      holderName: "",
      isValidHolder: "",
      race: "",
      isValidRace: "",
      ethnicity: "",
      isValidEthnicity: "",
      symptoms: {
        severe: 0,
        mild: 0,
        no: 0
      },
      isValidSymptoms: "",
      exposure: {
        no: 0,
        suspect: 0,
        yes: 0,
      },
      isValidExposure: "",
      category: {
        high: 0,
        low: 0,
      },
      isValidCategory: "",
      isHigh: false,
      isLow: false,
      psc: "",
      isValidPSC: "",
      date: null,
      isValidDate: "",
      errors: [],
      busySlots: [],
      submitted: false,
      modal: false,
    })
  }

  onModal = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleConsent = (e) => {
    this.setState({
      consent: !this.state.consent
    })
  }

  renderModal(){
    return(
      <div className={`modal inmodal`} id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" style={{display:"block"}}>
       <div className="modal-dialog modal-lg" role="document">
         <div className="modal-content">
           <div className="modal-header">
             <button type="button" className="close" data-dismiss="modal" onClick={this.onModal}>
               <span aria-hidden="true">x</span>
             </button>
           </div>
           <div className="modal-body modal-reduced-padding"  style={{overflowY: 'auto', height: '500px'}}>
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=17kFXCJos6ID8nDD3hR-HOCpu3kNJcAxP" width="100%" height="100%"></iframe>
           </div>
         </div>
       </div>
     </div>
    )
  }

  consent = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/consent`)
  }

  render() {
    return (
      <div>
            {this.state.submitted ?
              <Fragment>
                <div className="row">
                  <div className="col-xs-12 " style={{textAlign: 'center'}}>
                    <br/><br/>
                    <img src={LOGO} height="100"/>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 " style={{textAlign: 'center'}}>
                    <br/><br/>
                    <h3>Your appointment was scheduled. You should receive an email confirmation shortly.</h3>
                  </div>
                </div> 
                <div className="row">
                  <div className="col-xs-12 " style={{textAlign: 'center'}}>
                    <br/><br/>
                    <button className="btn btn-primary" onClick={this.back}>BACK</button>
                  </div>
                </div>                     
              </Fragment> 
              :
                <Fragment>
                        <div className="row">
                          <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{textAlign: 'center'}}>
                            <img className="hidden-xs pull-right" src={LOGO} height="100"/>
                            <img className="visible-xs" src={LOGO} height="100"/>
                          </div>
                          <div className="hidden-xs col-sm-8 ">
                            <div style={{margin: '15px', fontWeight: 'bold', color: "#E74C3C"}}>
                              <p>If you are seriously ill, please seek immediate medical care from a healthcare professional.</p>
                              <p>** If you are having a medical emergency, please call 9-1-1. Signs of a serious medical condition include, but are not limited to, severe shortness of breath or difficulty breathing, coughing up blood, chest pain, irregular heartbeat, persistent vomiting, or diarrhea. **</p>
                            </div>                      
                          </div>
                        </div>
                        <div className="row" style={{textAlign: 'center'}}>
                          <div className="col-xs-12 col-sm-12 col-md-6">
                            <div className="panel-body">
                              <div className="row">
                                <div className="col-xs-12">
                                  <h1 style={{fontWeight: 'bold', color: "#2471A3"}}>*** Book your Appointment! ***</h1>
                                  {window.location.href.split('?')[1] === 'florida' ? <h1 style={{fontWeight: 'bold', color: "#2471A3"}} >For 1-Hour PCR Test</h1>: ''}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Last Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidLastName}`} name="lastName" value={this.state.lastName} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>First Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidFirstName}`} name="firstName" value={this.state.firstName} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Date Of Birth<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidDOB}`} placeholder="MM/DD/YYYY" name="dob" value={this.state.dob} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Gender<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidGender}`} name="gender" value={this.state.gender} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Female">Female</option>
                                    <option value="Male">Male</option>
                                    <option value="Prefer not to answer">Prefer not to answer</option>
                                  </select>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Email<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidEmail}`} name="email" value={this.state.email} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Phone<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidPhone}`} name="phone" value={this.state.phone} placeholder="XXXXXXXXXX" onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                  <label>Home Address<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidAddress}`} name="address" value={this.state.address} onChange={this.onChange}/>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>City<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidCity}`} name="city" value={this.state.city} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>State<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidState}`} name="state" value={this.state.state} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    {states.map(item => <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>)}
                                  </select>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Zip<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidZip}`} name="zip" value={this.state.zip} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  
                                </div>
                              </div>
                            {this.state.isInsured === 'Yes' && <div className="row">                          
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Insurance Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidInsurance}`} name="insuranceName" value={this.state.insuranceName} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Policy Member ID<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidPolicy}`} name="policy" value={this.state.policy} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Relation to Insured<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidRelation}`} name="relation" value={this.state.relation} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Self">Self</option>
                                    <option value="Spouse">Spouse</option>
                                    <option value="Child">Child</option>
                                    <option value="Other">Other</option>
                                  </select>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Policy Holder Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidHolder}`} name="holderName" value={this.state.holderName} onChange={this.onChange}/>
                                </div>
                              </div>}
                              <div className="row">
                                <div className="col-xs-6">
                                  <label>Race<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidRace}`} name="race" value={this.state.race} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Black">Black</option>
                                    <option value="White">White</option>
                                    <option value="American Indian/Native American">American Indian/Native American</option>
                                    <option value="Native Hawaiian/Other Pacific Islander">Native Hawaiian/Other Pacific Islander</option>
                                    <option value="Other">Other</option>
                                    <option value="Prefer not to answer">Prefer not to answer</option>
                                  </select>
                                </div>
                                <div className="col-xs-6">
                                  <label>Ethnicity<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidEthnicity}`} name="ethnicity" value={this.state.ethnicity} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Hispanic/Latino">Hispanic/Latino</option>
                                    <option value="Non-hispanic/Latino">Non-hispanic/Latino</option>
                                    <option value="Prefer not to answer">Prefer not to answer</option>
                                  </select>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                  <div className="col-xs-12">
                                    <label>Symptoms<span style={{color:"red"}}>*</span></label>
                                    <table className="table table-condensed" style={{textAlign: 'left'}}>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="severe" checked={this.state.symptoms.severe} type="checkbox" onChange={this.onChangeSymptoms} />                                 
                                            </label>
                                          </td>
                                          <td> Severe Symptoms</td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="mild" checked={this.state.symptoms.mild} type="checkbox" onChange={this.onChangeSymptoms} />                                 
                                            </label>
                                          </td>
                                          <td> Mild Symptoms</td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="no" checked={this.state.symptoms.no} type="checkbox" onChange={this.onChangeSymptoms} />                                 
                                            </label>
                                          </td>
                                          <td> I have no symptoms</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div> 
                                  <div className="col-xs-12">
                                    <label>Exposure<span style={{color:"red"}}>*</span></label>
                                    <table className="table table-condensed" style={{textAlign: 'left'}}>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="no" checked={this.state.exposure.no} type="checkbox" onChange={this.onChangeExposure} />                                 
                                            </label>
                                          </td>
                                          <td> I do not believe I have been exposed</td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="suspect" checked={this.state.exposure.suspect} type="checkbox" onChange={this.onChangeExposure} />                                 
                                            </label>
                                          </td>
                                          <td> I suspect I may have been exposed</td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="yes" checked={this.state.exposure.yes} type="checkbox" onChange={this.onChangeExposure} />                                 
                                            </label>
                                          </td>
                                          <td> I have known exposure</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>  
                                </div> 
                                <div className="col-xs-12 col-sm-6">
                                  <div className='col-xs-12'>
                                    <label>What category you are in?<span style={{color:"red"}}>*</span></label>
                                    <table className="table table-condensed" style={{textAlign: 'left'}}>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="high" checked={this.state.category.high} type="checkbox" onChange={this.onChangeRisk} />                                 
                                            </label>
                                          </td>
                                          <td> 
                                            <strong>HIGH RISK <i className="fa fa-question-circle text-danger" onClick={this.clickHigh}></i></strong>
                                            <ul className={this.state.isHigh ? "" : "hidden"}>
                                              <li>I am 65 years of age or older</li>
                                              <li>I have been told by my doctor that I am very overweight or obese</li>
                                              <li>I have a chronic condition (e.g. diabetes, high blood pressure, kidney disease or on dialysis, liver disease, lung disease, etc.)</li>
                                              <li>I have a heart condition (e.g. previous heart attacks, heart failure, etc.)</li>
                                              <li>I have a neurological condition that affects my ability to cough (e.g. had a stroke)</li>
                                              <li>I am pregnant</li>
                                              <li>I regularly use tobacco or nicotine products (e.g. cigarettes, e-cigarettes, vapes, hookah, etc.)</li>
                                              <li>I am taking medication that weakens my immune system (e.g. steroids, chemotherapy, immunologics, etc.)</li>
                                              <li>I have a condition that weakens my immune system or makes it harder to fight infections (e.g. AIDS, cancer, lupus, rheumatoid arthritis, solid organ or bone marrow transplant, etc.)</li>
                                            </ul>
                                            
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="low" checked={this.state.category.low} type="checkbox" onChange={this.onChangeRisk} />                                 
                                            </label>
                                          </td>
                                          <td> 
                                            <strong>LOW RISK <i className="fa fa-question-circle text-danger" onClick={this.clickLow}></i></strong>
                                            <ul className={this.state.isLow ? "" : "hidden"}>
                                              <li>Non of the above</li>
                                            </ul>
                                            
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className='col-xs-12'>
                                    <label>Test<span style={{color:"red"}}>*</span></label>
                                    <table className="table table-condensed" style={{textAlign: 'left'}}>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <label>
                                              <input name="pcr" checked={this.state.pcr} type="checkbox" onChange={this.onChangeTest} />                                 
                                            </label>
                                          </td>
                                          <td> Covid-19 PCR Test</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>                                  
                                </div>
                              </div>
                              <div className="row">
                                <div className="hidden-xs hidden-sm col-md-12 col-lg-6">
                                  <label>Select Location<span style={{color:"red"}}>*</span></label>
                                  {window.location.href.split('?')[1] === 'florida' ? 
                                    <select className={`form-control input-sm ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                      <option value='PSC2180'>2180 SW 71st Terrace, Davie FL 33317</option>
                                    </select> :
                                    <select className={`form-control input-sm ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                      <option value="">Select</option>
                                      {PSCS.map(item => <option key={item.code} value={item.code}>{item.address}</option>)}
                                    </select>
                                  }
                                </div>
                                <div className="hidden-md hidden-lg col-xs-12 col-sm-12">
                                  <label>Select Location<span style={{color:"red"}}>*</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button className="btn btn-primary btn-xs" onClick={this.onModal}><i className="fa fa-map-marker"> Google Maps</i></button></label>
                                    <select className={`form-control input-sm ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                      <option value="">Select</option>
                                      {PSCS.map(item => <option key={item.code} value={item.code}>{item.address}</option>)}
                                    </select>                              
                                </div>
                                { this.state.psc && 
                                  <Fragment>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                      <label>Select Date<span style={{color:"red"}}>*</span></label>
                                      <input className={`form-control input-sm ${this.state.isValidDate}`} min={moment().format('YYYY-MM-DD')} type="date" name="date" value={this.state.date} onChange={this.onChange}/>
                                    </div>                                    
                                  </Fragment>
                                }
                              </div>
                              <div className="row">
                                <div className="col-xs-12" style={{textAlign: 'left'}}>
                                  <ul style={{color: 'red'}}>
                                    {this.state.errors.map((err, index) => <li style={{float: 'left', margin: '0 10px', width: '200px'}} key={index}>{err}</li>)}
                                  </ul>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12" style={{textAlign: 'left'}}>
                                  <a onClick={this.consent}><h3 style={{textDecoration: "underline"}}>Patient Consent Form</h3></a>
                                  <input type="checkbox" name="consent" value={this.state.consent} checked={this.state.consent} onChange={this.handleConsent}/> I acknowledge that I have read Patient Consent Form above.
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12">
                                  <br/>
                                  <button className="btn btn-primary btn-block" disabled={this.state.loading} onClick={this.submit}>{this.state.loading ? '...Submitting' : 'Submit an Appointment'}</button>
                                </div>
                              </div>
                            </div>                    
                          </div>
                          <div className="hidden-xs hidden-sm col-md-6">
                            <div className="panel-body" style={{overflowY: 'auto', height: '900px'}}>
                              {window.location.href.split('?')[1] === 'florida' ? 
                                <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1Ji8By_uks3JitUVL-y_1NKL3dt8gLtgN&ehbc=2E312F" width="100%" height="100%"></iframe> :
                                <iframe src="https://www.google.com/maps/d/u/0/embed?mid=17kFXCJos6ID8nDD3hR-HOCpu3kNJcAxP" width="100%" height="100%"></iframe>
                              }                      
                            </div>                    
                          </div>
                          {this.state.modal && this.renderModal()}
                        </div>
                      </Fragment>
            }
            
          </div>
    )
  }
}
export default Kameo
